import React from "react";
import { motion } from "framer-motion";

export default function StatCard({ label, value, icon: Icon, accent = "blue", testId, delay = 0, compact = false }) {
  const accents = {
    blue: "from-brand-blue/20 to-blue-500/5 text-brand-blue dark:text-blue-400",
    gold: "from-brand-gold/20 to-amber-500/5 text-amber-500",
    green: "from-emerald-500/20 to-emerald-500/5 text-emerald-500",
    red: "from-rose-500/20 to-rose-500/5 text-rose-500",
    slate: "from-slate-500/20 to-slate-500/5 text-slate-500",
  };
  const accentText = accents[accent].split(" ").slice(2).join(" ");
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay }}
      data-testid={testId}
      className={`relative overflow-hidden rounded-xl border border-border bg-card min-w-0 ${compact ? "p-3" : "p-5"}`}
    >
      <div className={`absolute inset-0 bg-gradient-to-br ${accents[accent]} opacity-60 pointer-events-none`} />
      <div className="relative flex items-start justify-between gap-2 min-w-0">
        <div className="min-w-0 flex-1">
          <div className={`uppercase tracking-[0.12em] text-muted-foreground font-semibold leading-tight ${compact ? "text-[10px]" : "text-xs tracking-[0.2em]"}`}>
            {label}
          </div>
          <div
            className={`mt-1.5 font-heading font-bold text-foreground tabular-nums break-words leading-none ${
              compact ? "text-base sm:text-xl" : "text-2xl sm:text-3xl mt-2"
            }`}
          >
            {value}
          </div>
        </div>
        {Icon && (
          <div className={`shrink-0 rounded-lg bg-background/60 backdrop-blur ${accentText} ${compact ? "p-1.5" : "p-3 rounded-xl"}`}>
            <Icon className={compact ? "h-3.5 w-3.5" : "h-5 w-5"} />
          </div>
        )}
      </div>
    </motion.div>
  );
}
